import type { CallBackProps } from "react-joyride";

let lastScrollKey = "";
let lastScrollAt = 0;

function isScrollableTarget(target: unknown): target is string {
  if (typeof target !== "string") {
    return false;
  }

  const normalized = target.trim().toLowerCase();
  return normalized !== "" && normalized !== "body" && normalized !== "html";
}

export function autoScrollJoyrideStep(data: Pick<CallBackProps, "step" | "index" | "type">) {
  const target = data.step?.target;

  if (!isScrollableTarget(target)) {
    return;
  }

  const scrollKey = `${data.index}:${data.type}:${target}`;
  const now = Date.now();

  if (lastScrollKey === scrollKey && now - lastScrollAt < 180) {
    return;
  }

  lastScrollKey = scrollKey;
  lastScrollAt = now;

  const scrollToTarget = () => {
    const element = document.querySelector(target) as HTMLElement | null;
    if (!element) {
      return;
    }

    element.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
  };

  window.requestAnimationFrame(scrollToTarget);
  window.setTimeout(scrollToTarget, 120);
}
